var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.8 325.6",
    style: {
      enableBackground: "new 0 0 279.8 325.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,284.3c0,0.1,0,0.2,0,0.2c0,20.9,18,37.9,40.3,37.9s40.3-16.9,40.3-37.9c0-0.1,0-0.2,0-0.2H99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.6,237L232.3,187c0-15.3,0-52.8,0-62.4c0-42.1-31.9-77.2-74.3-85.1V20.2c0-9.4-8.1-17-18.1-17 s-18.1,7.6-18.1,17v19.2c-42.4,7.9-74.3,43-74.3,85.1c0,16.5,0,52.9,0,62.4L11.2,237c-3.8,5.3-4.2,12.1-1.1,17.7 s9.4,9.2,16.2,9.2h227.1c6.8,0,13-3.5,16.2-9.2C272.8,249.1,272.4,242.3,268.6,237z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.bc8eef1acfbb7b6d8f72b2233a1c69e7.svg";
export { ForwardRef as ReactComponent };